import React from "react";
import "../Styles/footer.css";
import logo from "./logoo.png";

const Footer = () => {
  return (
    <footer className="footer__below">
      <div className="footer__sec">
        <div className="row_footer">

          {/* Logo + description */}
          <div className="col_footerb">
            <img src={logo} alt="Xceed Office" className="footer_logo" />

            <p>
              Xceed Office delivers vibrant and sustainable workspaces for
              today’s creators and leaders. We blend style, comfort, and smart
              design to spark ideas and meaningful connections.
            </p>
          </div>

          {/* Company */}
          <div className="col_footer">
            <h3>Quck Links</h3>

            <a href="/about">About</a>
            <br />
            <a href="/locations">Locations</a>
          <br />
            <a href="/Pricing">Pricing</a>
            <br />
          
            <a href="/contact">Contact</a>

          </div>

          {/* Contact */}
          <div className="col_footer">
            <h3>Contact Us</h3>

            <p>
              <i className="ri-phone-fill"></i>
              <a href="tel:+12817176060">+1 (281) 270-6431</a>
            </p>

            <p>
              <i className="ri-mail-line"></i>
              <a href="mailto:info@xceedoffice.com">
                info@xceedoffice.com
              </a>
            </p>

          </div>

        </div>

        {/* Bottom copyright */}
        <div className="footer_bottom">
          <p>© 2025 Xceed Office. All rights reserved.</p>
        </div>
      </div>
    </footer>
  );
};

export default Footer;